import { render } from "./PollVotersDetails.vue?vue&type=template&id=935ace76&scoped=true"
import script from "./PollVotersDetails.vue?vue&type=script&lang=js"
export * from "./PollVotersDetails.vue?vue&type=script&lang=js"

import "./PollVotersDetails.vue?vue&type=style&index=0&id=935ace76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935ace76"]])

export default __exports__